import { loadImage } from "iso-canvas";

export default async function imgClipToBase64(url, clip) {
  try {
    const { x, y, width, height } = clip;
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    const img = await loadImage(url, { crossOrigin: "anonymous" });
    if (ctx === null) return null;
    ctx.drawImage(img, -x, -y, img.width, img.height);
    const dataURL = canvas.toDataURL();
    return dataURL;
  } catch (err) {
    console.log(err);
    return null;
  }
}
